import { STATUS_TYPE } from '../../../enum';

export interface IInitialState {
  id?: string;
  labelEn: string;
  labelAr: string;
  position: string;
  icon: string;
  activeState: boolean;
  isLand: boolean;
}

export interface GetPropertyCategory {
  id: string;
}

export interface FindPropertyCategory {
  activeOnly?: boolean;
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchPropertyCategory {
  id?: string;
  labelEn: string;
  labelAr: string;
  position: string;
  icon: string;
  activeState: boolean;
  isLand: boolean;
}

export interface PropertyCategory {
  id: string;
  labelEn: string;
  labelAr: string;
  position: string;
  icon: string;
  activeState: boolean;
  isLand: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: PropertyCategory[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
